export default __webpack_public_path__ + "static/media/pexels-pixabay-40751.fb7cfff3.jpg";